<template>
  <div class="blade">
    <modal :name="name" :title="title" :canClose="canClose">
      <slot />
      <template slot="close">
        <icon icon="x-small" />
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    canClose: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">

.blade {
  .modal-wrap {
    .modal {
      outline: none;
      @include breakpoint(small) {
        top: 0;
        bottom: 0;
        left: auto;
        right: 0;
        transform: none;
        overflow-x: hidden;

        .modal-inner {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
}

.blade {
  .modal-wrap {
    .modal {
      ::v-deep .modal-wrap {
        height: 100%;
        width: 100%;
      }

      .modal-inner {
        min-height: 100%;
        padding: $d-xx-large $d-med-small $d-x-large;
      }

      h2 {
        @include title-med;
        @include deprecated-f-color-dark;
      }

      .close-modal-button {
        height: $d-med-small;
        width: $d-med-small;
        left: $d-small;
        right: auto;
        padding: 0;

        @include breakpoint(medium) {
          left: $space-050;
        }
      }

      @include breakpoint(small) {
        min-width: 340px;
        max-width: 460px;
        @include shadow(left);

        .modal-inner {
          padding: $d-xx-large $d-small $d-x-large;
        }

        fieldset {
          padding-top: $d-med-large;
        }

        .input-requirements {
          @include body-sml;
          font-weight: $f-weight-regular;
        }
      }
    }

    .external-content {
      margin-top : $space-060;

      p, div {
        margin-bottom: $space-040;
        display: flex;
        flex-direction: column;
      }

      br {
        margin-bottom: $space-020;
      }

      a {
        font-weight: $f-weight-medium;
        color: inherit;
      }
    }

    .modal-inner-content {
      display: flex;
      flex-direction: column;
      height: 100%;

      & > ul,
      & > button,
      fieldset {
        flex-shrink: 0;
      }

      form {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        flex-shrink: 0;
        justify-content: space-between;
      }

      h2 {
        @include label-serif-lrg;
      }
    }

    .filter-tags {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin: $d-tiny 0 $d-small #{-$d-tiny/2};
    }

    .reset-button {
      position: absolute;
      right: $d-med-small;
      top: $d-med-small;
      width: auto;
      margin-right: -$d-x-small;
      @include label-x-sml;
      @include breakpoint(medium) {
        right: $d-med-large;
      }
    }
  }
}
</style>
